import styled from '@emotion/styled';
import { Text } from 'ds/components/typography';

export const SavedSearchPageWrapper = styled.div`
  margin: 0 auto;
  max-width: 648px;
  flex-direction: column;
  display: flex;
  min-height: calc(100vh - 65px);
`;

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 56px;
  padding: 0 ${({ theme }) => theme.spacing(3)};
`;

export const ContentWrapper = styled.div`
  flex-grow: 1;
  padding-top: ${({ theme }) => theme.spacing(3)};
  ${({ theme }) => theme.media.showAt({ from: 2 })`
    padding-top: ${theme.spacing(5)};
  `}
`;

export const FooterWrapper = styled.div`
  padding-bottom: ${({ theme }) => theme.spacing(3)};
  ${({ theme }) => theme.media.showAt({ to: 2 }) `
    padding-left: ${theme.spacing(3)};
    padding-right: ${theme.spacing(3)};
  `};
`;

export const TabsHeaderWrapper = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.colors.neutrals.grey8};

  ${({ theme }) => theme.media.showAt({ from: 2 })`
    justify-content: center;
  `}
`;

export const TabHeader = styled.div<{ isActive: boolean }>`
  display: flex;
  align-items: center;
  padding: ${({ theme }) => theme.spacing(1.5, 0)};
  cursor: pointer;

  ${({ theme, isActive }) => `
    border-bottom: 2px solid ${isActive ? theme.colors.neutrals.grey1 : 'transparent'};
  `}

  ${({ theme }) => theme.media.showAt({ from: 2 })`
    padding: ${theme.spacing(1.5, 4)};
  `}

  ${Text} {
    // fixed width to avoid horizontal layout shift
    min-width: 130px;
    text-align: center;
  }
`;
